import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createCategory as universalCreateCategory, bulkCreateCategory as universalBulkCreateCategory, updateCategory as universalUpdateCategory, deleteCategory as universalDeleteCategory, queryCategories as universalQueryCategories, assignEvents as universalAssignEvents, bulkAssignEvents as universalBulkAssignEvents, bulkAssignEventsAsync as universalBulkAssignEventsAsync, unassignEvents as universalUnassignEvents, bulkUnassignEvents as universalBulkUnassignEvents, bulkUnassignEventsAsync as universalBulkUnassignEventsAsync, listEventCategories as universalListEventCategories, reorderCategoryEvents as universalReorderCategoryEvents, } from './events-v1-category.universal';
import { State, SortOrder, CategoryFieldset, WebhookIdentityType, } from './events-v1-category.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.events.v1.category', module_name: 'wix-events.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createCategory: (category) => {
            const methodLogData = {
                method_name: 'createCategory',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.createCategory',
            };
            return universalCreateCategory(category, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateCategory: (categories) => {
            const methodLogData = {
                method_name: 'bulkCreateCategory',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.bulkCreateCategory',
            };
            return universalBulkCreateCategory(categories, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateCategory: (_id, category) => {
            const methodLogData = {
                method_name: 'updateCategory',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.updateCategory',
            };
            return universalUpdateCategory(_id, category, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteCategory: (categoryId) => {
            const methodLogData = {
                method_name: 'deleteCategory',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.deleteCategory',
            };
            return universalDeleteCategory(categoryId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryCategories: (options) => {
            const methodLogData = {
                method_name: 'queryCategories',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.queryCategories',
            };
            return universalQueryCategories(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        assignEvents: (categoryId, eventId) => {
            const methodLogData = {
                method_name: 'assignEvents',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.assignEvents',
            };
            return universalAssignEvents(categoryId, eventId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAssignEvents: (categoryId, options) => {
            const methodLogData = {
                method_name: 'bulkAssignEvents',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.bulkAssignEvents',
            };
            return universalBulkAssignEvents(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAssignEventsAsync: (categoryId, options) => {
            const methodLogData = {
                method_name: 'bulkAssignEventsAsync',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.bulkAssignEventsAsync',
            };
            return universalBulkAssignEventsAsync(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        unassignEvents: (categoryId, eventId) => {
            const methodLogData = {
                method_name: 'unassignEvents',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.unassignEvents',
            };
            return universalUnassignEvents(categoryId, eventId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUnassignEvents: (categoryId, options) => {
            const methodLogData = {
                method_name: 'bulkUnassignEvents',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.bulkUnassignEvents',
            };
            return universalBulkUnassignEvents(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUnassignEventsAsync: (categoryId, options) => {
            const methodLogData = {
                method_name: 'bulkUnassignEventsAsync',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.bulkUnassignEventsAsync',
            };
            return universalBulkUnassignEventsAsync(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listEventCategories: (eventId) => {
            const methodLogData = {
                method_name: 'listEventCategories',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.listEventCategories',
            };
            return universalListEventCategories(eventId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        reorderCategoryEvents: (categoryId, options) => {
            const methodLogData = {
                method_name: 'reorderCategoryEvents',
                service_name: 'wix.events.categories.CategoryManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.category,environment=velo-frontend,method-fqn=wix.events.categories.CategoryManagement.reorderCategoryEvents',
            };
            return universalReorderCategoryEvents(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        State,
        SortOrder,
        CategoryFieldset,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=events-v1-category.frontend.js.map